import { Routes, Route, NavLink, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Vtt from './pages/Vtt';
import Sheet from './pages/Sheet';
import Party from './pages/Party';
import Lore from './pages/Lore';
import LevelUp from './pages/LevelUp';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import Admin from './pages/Admin';
import ProtectedRoute from './lib/ProtectedRoute';
import AdminRoute from './lib/AdminRoute';
import { useAuth } from './lib/AuthContext';
import { isAdmin } from './lib/auth';

export default function App() {
  const { user, signOut } = useAuth();
  const admin = isAdmin(user);

  return (
    <div className="app-shell">
      <nav className="app-nav">
        <span className="app-nav__brand">GoobDoob VTT</span>
        {user && (
          <>
            <NavLink to="/dashboard" className="app-nav__link">Dashboard</NavLink>
            <NavLink to="/vtt" className="app-nav__link">VTT</NavLink>
            <NavLink to="/sheet" className="app-nav__link">Sheet</NavLink>
            <NavLink to="/party" className="app-nav__link">Party</NavLink>
            <NavLink to="/lore" className="app-nav__link">Lore</NavLink>
            <NavLink to="/levelup" className="app-nav__link">Level Up</NavLink>
            {admin && <NavLink to="/admin" className="app-nav__link">Admin</NavLink>}
            <span style={{ marginLeft: 'auto', color: 'var(--fg-muted)' }}>
              {user.email || user.username}
            </span>
            <button
              onClick={signOut}
              className="app-nav__link"
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            >
              Sign out
            </button>
          </>
        )}
      </nav>
      <main className="app-main">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route
            path="/"
            element={<Navigate to="/dashboard" replace />}
          />
          <Route
            path="/dashboard"
            element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
          />
          <Route
            path="/vtt"
            element={<ProtectedRoute><Vtt /></ProtectedRoute>}
          />
          <Route
            path="/sheet"
            element={<ProtectedRoute><Sheet /></ProtectedRoute>}
          />
          <Route
            path="/party"
            element={<ProtectedRoute><Party /></ProtectedRoute>}
          />
          <Route
            path="/lore"
            element={<ProtectedRoute><Lore /></ProtectedRoute>}
          />
          <Route
            path="/levelup"
            element={<ProtectedRoute><LevelUp /></ProtectedRoute>}
          />
          <Route
            path="/admin"
            element={<AdminRoute><Admin /></AdminRoute>}
          />
        </Routes>
      </main>
    </div>
  );
}
